export default "__VITE_ASSET__bxiFGaCk__"